import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=513d309e&"
import script from "./Terms.vue?vue&type=script&lang=js&"
export * from "./Terms.vue?vue&type=script&lang=js&"
import style0 from "./Terms.vue?vue&type=style&index=0&id=513d309e&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('513d309e')) {
      api.createRecord('513d309e', component.options)
    } else {
      api.reload('513d309e', component.options)
    }
    module.hot.accept("./Terms.vue?vue&type=template&id=513d309e&", function () {
      api.rerender('513d309e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/views/internal/check-in/Terms.vue"
export default component.exports